"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAPITAL_STRUCTURE_COLORs = exports.CAPITAL_STRUCTURE_LABELS = exports.CAPITAL_STRUCTURE_VARIABLES = void 0;
const utils_1 = require("@hum/icm-app/src/components/FinancialInsights/FinancialInsightsDocument/utils");
exports.CAPITAL_STRUCTURE_VARIABLES = ['equityPaidInCapital', 'debtTotal'];
exports.CAPITAL_STRUCTURE_LABELS = ['Equity', 'Debt'];
exports.CAPITAL_STRUCTURE_COLORs = [utils_1.Color.IndigoDye, utils_1.Color.TealDeer];
//# sourceMappingURL=FinancialInsights.js.map